import { useState, useEffect } from 'react';
import { audioAPI } from '../lib/api';
import { Music, Play, Pause, SkipBack, SkipForward, Volume2 } from 'lucide-react';

export default function AudioHUD() {
  const [tracks, setTracks] = useState([]);
  const [currentTrack, setCurrentTrack] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    audioAPI.list().then(r => setTracks(r.data)).catch(() => {});
  }, []);

  const track = tracks[currentTrack];

  if (tracks.length === 0) {
    return (
      <div className="pointer-events-auto fixed bottom-4 right-4 z-30 glass-panel px-4 py-3 flex items-center gap-3" data-testid="audio-hud-empty">
        <Music className="text-[#2F8A92]" size={16} />
        <span className="font-hud text-xs text-[#52525B] tracking-wider">NO AUDIO LOADED</span>
      </div>
    );
  }

  return (
    <div className="pointer-events-auto fixed bottom-4 right-4 z-30 glass-panel px-4 py-3 flex items-center gap-4" data-testid="audio-hud">
      {/* Equalizer bars */}
      <div className="flex items-end gap-px h-4">
        {[0.2, 0.6, 0.4, 0.8, 0.3].map((d, i) => (
          <div
            key={i}
            className="eq-bar"
            style={{
              animationDelay: `${d}s`,
              animationPlayState: isPlaying ? 'running' : 'paused',
            }}
          />
        ))}
      </div>

      <div className="flex items-center gap-2">
        <button
          data-testid="audio-prev"
          onClick={() => setCurrentTrack(Math.max(0, currentTrack - 1))}
          className="text-white/80 hover:text-[#2F8A92] transition-all duration-300"
        >
          <SkipBack size={14} />
        </button>
        <button
          data-testid="audio-play-pause"
          onClick={() => setIsPlaying(!isPlaying)}
          className="text-[#2F8A92] hover:text-[#66FAFF] transition-all duration-300"
        >
          {isPlaying ? <Pause size={18} /> : <Play size={18} />}
        </button>
        <button
          data-testid="audio-next"
          onClick={() => setCurrentTrack(Math.min(tracks.length - 1, currentTrack + 1))}
          className="text-white/80 hover:text-[#2F8A92] transition-all duration-300"
        >
          <SkipForward size={14} />
        </button>
      </div>

      <div className="max-w-[120px]">
        <p className="font-hud text-xs text-[#2F8A92] tracking-wider truncate">{track?.title}</p>
        <p className="font-mono text-[10px] text-[#52525B] truncate">{track?.description}</p>
      </div>

      <Volume2 size={14} className="text-[#52525B]" />
    </div>
  );
}
